module.exports = __webpack_public_path__ + "static/media/stop-icon-circle.a63053c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/stop-icon-circle.svg
// module id = 635
// module chunks = 0